export const initialState = {};
export const PORTFOLIO_REDIRECT = 'PORTFOLIO_REDIRECT';